import type { SessionContext } from './api/generated/types_web';

export const queryKeys = {
  app: (appId: string, sessionContext: SessionContext) =>
    ['app', appId, sessionContext.userLanguage, sessionContext.userMaturity] as const,
  productIntro: (appId: string, sessionContext: SessionContext) =>
    [...queryKeys.app(appId, sessionContext), 'productIntro'] as const,
  onboarding: (appId: string, sessionContext: SessionContext) =>
    [...queryKeys.app(appId, sessionContext), 'onboarding'] as const,
  userExperiences: () => ['userExperiences'] as const,
  screen: (sessionContext: SessionContext, screenId: string) =>
    [
      'screen',
      sessionContext.userLanguage,
      sessionContext.userMaturity,
      screenId,
    ] as const,
  homeScreen: (sessionContext: SessionContext, screenId: string) =>
    [
      'homeScreen',
      sessionContext.userLanguage,
      sessionContext.userMaturity,
      screenId,
    ] as const,
  liveScreen: (sessionContext: SessionContext, screenId: string) =>
    [
      'liveScreen',
      sessionContext.userLanguage,
      sessionContext.userMaturity,
      screenId,
    ] as const,
  curatedScreen: (sessionContext: SessionContext, screenId: string) =>
    [
      'curatedScreen',
      sessionContext.userLanguage,
      sessionContext.userMaturity,
      screenId,
    ] as const,
  sportsScreen: (sessionContext: SessionContext, screenId: string) =>
    [
      'sportsScreen',
      sessionContext.userLanguage,
      sessionContext.userMaturity,
      screenId,
    ] as const,
  kidsScreen: (sessionContext: SessionContext, screenId: string) =>
    [
      'kidsScreen',
      sessionContext.userLanguage,
      sessionContext.userMaturity,
      screenId,
    ] as const,
  container: (sessionContext: SessionContext, containerId: string) =>
    [
      'container',
      sessionContext.userLanguage,
      sessionContext.userMaturity,
      containerId,
    ] as const,
  search: (sessionContext: SessionContext, searchQuery: string) =>
    [
      'search',
      sessionContext.userLanguage,
      sessionContext.userMaturity,
      searchQuery,
    ] as const,
  searchRestoreState: (sessionContext: SessionContext, searchQuery: string) =>
    [
      'searchRestoreState',
      sessionContext.userLanguage,
      sessionContext.userMaturity,
      searchQuery,
    ] as const,
  gridContainer: (sessionContext: SessionContext, containerId: string) =>
    [
      'gridContainer',
      sessionContext.userLanguage,
      sessionContext.userMaturity,
      containerId,
    ] as const,
  gridCollection: (sessionContext: SessionContext, collectionId: string) =>
    [
      'gridCollection',
      sessionContext.userLanguage,
      sessionContext.userMaturity,
      collectionId,
    ] as const,
  grid: (sessionContext: SessionContext, id: string, isContainer: boolean) =>
    isContainer
      ? queryKeys.gridContainer(sessionContext, id)
      : queryKeys.gridCollection(sessionContext, id),
  moviesScreen: (sessionContext: SessionContext, screenId: string) =>
    [
      'moviesScreen',
      sessionContext.userLanguage,
      sessionContext.userMaturity,
      screenId,
    ] as const,
  myList: (sessionContext: SessionContext) =>
    ['myList', sessionContext.userLanguage, sessionContext.userMaturity] as const,
};
